import React, { memo } from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import Emoji from '../../../../../components/Emoji/Emoji';

const useStyles = makeStyles(({ palette, spacing }) => ({
  title: {
    fontSize: 32,
    lineHeight: 1.25,
    fontWeight: 'bold',
  },
  firstEmoji: {
    marginLeft: spacing(1),
  },
  link: {
    display: 'inline',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  emailText: {
    fontWeight: 'bold',
    color: palette.green.fruitSalad,
  },
}));

export interface IThankYouSentTitleProps {
  recipientEmail: string;
  gl?: string;
  isDonation?: boolean;
}

const ThankYouSentTitle = ({ recipientEmail, gl = 'gift', isDonation = false }: IThankYouSentTitleProps) => {
  const classes = useStyles();
  return (
    <Box py={[2, 8]} px={2} mx={[2, 'auto']} color="text.primary" textAlign="center">
      <Typography className={classes.title} data-testid="thankYouSentTitle">
        Your thank you message has been sent!
        <Emoji emoji="foldedHands" overrideSpanClass={classes.firstEmoji} />
      </Typography>
      <Box maxWidth={[400]} mx={[2, 'auto']} mt="4px" textAlign="center">
        <Typography className="Lato-Regular">
          Remember your confirmation details will be sent to your email at&nbsp;
          <span className={classes.emailText}>{recipientEmail}</span>.{' '}
          {isDonation ? 'Thank you for your generosity!' : `Enjoy your ${gl}!`}
        </Typography>
      </Box>
    </Box>
  );
};

export default memo(ThankYouSentTitle);
